import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import PlanAssigmentLeftWrapper from "./LeftWrapper";
import "./PlanAssigmentDrawer.scss";
import { setDrawerVisible } from "./PlanAssignment.slice";

const PlanAssigmentDrawer = (props: any) => {
  const isMobileDrawerVisible: any = useAppSelector((state) => state.PlanAssignment.isMobileDrawerVisible);

  const dispatch = useAppDispatch();
  return (
    <div className="plan-assignment-drawer-component">
      <SwipeableDrawer
        className="plan-assignment-drawer"
        anchor="left"
        open={isMobileDrawerVisible}
        onClose={() => dispatch(setDrawerVisible(false))}
        onOpen={() => dispatch(setDrawerVisible(false))}
      >
        <PlanAssigmentLeftWrapper isCross={true} {...props} />
      </SwipeableDrawer>
    </div>
  );
};

export default PlanAssigmentDrawer;
